import React from 'react';
import {truncate} from 'lodash';
import {t} from '@lingui/core/macro';

import {colorMonitorPingMessage} from '../../lib/colors';

import StatusBadge from './StatusBadge';

import styles from './StatusBadge.module.scss';

interface IMonitorPingMessageBadgeProps {
    code: number | null,
    message: string,
    isPaused?: boolean,
    forceActiveColor?: boolean,
}

const MonitorPingMessageBadge: React.FC<IMonitorPingMessageBadgeProps> = ({
    code,
    message,
    isPaused,
    forceActiveColor,
}) => {
    if (code === null) return <>{t`Проверяется…`}</>;

    const shouldShowActiveColor = forceActiveColor || !isPaused;
    const color = colorMonitorPingMessage(Number(code));

    return (
        <StatusBadge
            color={color}
            backgroundColor={shouldShowActiveColor ? color : null}
            label={truncate(message, {length: 40})}
            className={isPaused ? styles.isPaused : undefined}
        />
    );
};

export default MonitorPingMessageBadge;
